import React from 'react';
import __ from 'core/lib/localization';
import { PricingCard } from './pricing-card';

export const FreeTrialPricingCard = () => {
  return (
    <PricingCard
      cta={'Download now'}
      featureTitle={__('2 sample stories', 'plans.twoSampleStories')}
      pricingExplanation={__(
        'No credit card required',
        'plans.noCreditCardRequired'
      )}
      normalPrice={0}
      price={0}
      title={__('Free trial', 'plans.freeTrial')}
      type={'free-trial'}
      onCtaClick={() => {
        window.open('https://get.lupa.app');
      }}
    />
  );
};
